import { useParams } from 'react-router-dom';

export default function useCurrentContextId() {
  const { ctxId } = useParams();

  return ctxId ?? null;
}

export const useCurrentOrgId = () => {
  const { shortname } = useParams();

  return shortname ?? null;
};
